

















































































































































































































































































import {
  computed,
  defineComponent,
  nextTick,
  ref,
  useRoute,
  PropType,
  toRefs,
  watch,
  vue3Model
} from '~/utils/nuxt3-migration'
import CSlider from '~/components/shared/configurable/slider/CSlider.vue'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import { formatNumber } from '~/utils/number'
import { useDeps } from '~/compositions/dependency-container'
import LoanService from '~/services/loan/LoanService'
import { LoanMerchantName } from '~/models/loan'
import { useLogger } from '~/compositions/logger'
import TbiCalculatoriFrameModal from '~/components/car/classifieds/view/partials/loans/calculator/tbi/TbiCalculatoriFrameModal.vue'
import {
  TBI_BLACK_FRIDAY_INTEREST,
  TBI_DEFAULT_INTEREST,
  TBI_MAX_AUTO_LOAN_AMOUNT,
  TBI_MAX_GENERIC_LOAN_AMOUNT,
  TBI_MIN_AUTO_LOAN_AMOUNT,
  TBI_MIN_GENERIC_LOAN_AMOUNT
} from '~/constants/loan/tbi'
import { debounce } from '~/utils/function'
import { DEBOUNCE_SWIFT } from '~/constants/debounce'
import LoanCalculatorTimeButton from '~/components/car/classifieds/view/partials/loans/calculator/LoanCalculatorTimeButton.vue'
import { arraysEqual } from '~/utils/array'
import { v4 as uuidv4 } from 'uuid'
import { OnlineLoanType } from '~/constants/loan/loans'
import LoanPerks from '~/components/car/classifieds/view/partials/loans/perks/LoanPerks.vue'
import CAccordion from '~/components/shared/configurable/accordion/CAccordion.vue'
import LoanCalculatorOpener from '~/components/car/classifieds/view/partials/loans/calculator/LoanCalculatorOpener.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import TbiInfoModal from '~/components/car/classifieds/view/partials/loans/calculator/tbi/TbiInfoModal.vue'
import { defineComponentTranslations } from '~/utils/i18n'
import { useI18n } from '~/compositions/i18n'
import { useBlackFriday } from '~/compositions/black-friday'

import CPrice from '~/components/shared/configurable/CPrice.vue'
import { useUserAgent } from '~/compositions/user-agent'

export default defineComponent({
  model: vue3Model,
  props: {
    modelValue: { type: Boolean, default: false },
    sessionId: {
      type: String,
      default: () => uuidv4()
    },
    loanType: {
      type: String as PropType<OnlineLoanType>,
      required: false,
      default: 'auto-loan'
    },
    simple: {
      type: Boolean,
      required: false,
      default: false
    },
    collapsible: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    CPrice,
    TbiInfoModal,
    CImg,
    LoanCalculatorOpener,
    LoanPerks,
    LoanCalculatorTimeButton,
    CSlider,
    TbiCalculatoriFrameModal,
    CAccordion
  },
  setup(props, { emit }) {
    const { loanType, modelValue } = toRefs(props)
    const { state } = useNamespacedStore<ClassifiedViewState>(
      CLASSIFIED_VIEW_NS
    )
    const [loanService] = useDeps(LoanService)
    const logger = useLogger()
    const route = useRoute()
    const { t } = useI18n()
    const internalExpanded = ref(modelValue.value)
    const { isMobile } = useUserAgent()

    watch(modelValue, (newVal: boolean) => {
      internalExpanded.value = newVal
    })

    const { isWithinTbiBlackFridayPeriod } = useBlackFriday()

    const classifiedRawPrice = computed(
      () => state.classified?.price.extra.raw_price || 0
    )

    const sliderRef = ref<typeof CSlider | null>(null)

    // Maybe change these values later, when the business logic is finalized
    // TODO: handle <1000 vehicles
    const minLoanAmount = computed<number>(() =>
      loanType.value === 'consumer-loan'
        ? TBI_MIN_GENERIC_LOAN_AMOUNT
        : TBI_MIN_AUTO_LOAN_AMOUNT
    )
    const maxLoanAmount = computed<number>(() => {
      if (
        [
          '__landing_pages_tbi_blackfriday',
          '__landing_pages_tbi',
          '__landing_pages_finance'
        ].includes(route.value.name as string)
      ) {
        return 15000
      }

      const maxToUse =
        loanType.value === 'consumer-loan'
          ? TBI_MAX_GENERIC_LOAN_AMOUNT
          : TBI_MAX_AUTO_LOAN_AMOUNT
      if (
        ['consumer-loan', 'tbi-consumer-loan-property'].includes(loanType.value)
      ) {
        return maxToUse
      } else if (classifiedRawPrice.value > maxToUse) {
        return maxToUse
      } else if (classifiedRawPrice.value < minLoanAmount.value) {
        return minLoanAmount.value
      }
      return Math.trunc(classifiedRawPrice.value)
    })

    const initLoanAmount = computed(() => {
      if (loanType.value === 'consumer-loan') {
        if (classifiedRawPrice.value > TBI_MAX_GENERIC_LOAN_AMOUNT) {
          return TBI_MAX_GENERIC_LOAN_AMOUNT
        } else if (classifiedRawPrice.value < minLoanAmount.value) {
          return minLoanAmount.value
        }
        return classifiedRawPrice.value
      }
      return maxLoanAmount.value
    })
    const loanAmount = ref(initLoanAmount.value)
    const liveLoanAmount = ref(initLoanAmount.value)

    const monthModeTrigger = computed(() => {
      return loanType.value === 'consumer-loan' && liveLoanAmount.value <= 500
    })

    const monthMode = ref<boolean>(monthModeTrigger.value)

    const loanInstallments = computed(() =>
      monthModeTrigger.value ? selectedTime.value : selectedTime.value * 12
    )

    const selectedTime = ref(monthModeTrigger.value ? 12 : 4) // 12 months : 4 years

    const getStaticLoanInstallment = () => {
      const interestToUse = isWithinTbiBlackFridayPeriod()
        ? TBI_BLACK_FRIDAY_INTEREST
        : TBI_DEFAULT_INTEREST
      const loanFeeToUse = isWithinTbiBlackFridayPeriod() ? 0 : 100
      return loanService.calculateTbiInstallmentAmount(
        Number(loanAmount.value),
        loanInstallments.value,
        interestToUse,
        loanFeeToUse
      )
    }
    const loanInstallment = ref(getStaticLoanInstallment())
    const loadingLoanInfo = ref(false)
    const loanModalIsShown = ref(false)

    const inputRef = ref(null)
    const showInput = ref(false)

    const showTbiInfoModal = ref(false)

    function timeButtonIsSelected(time: number): boolean {
      return selectedTime.value === time
    }

    function handleTimeButtonClick(time: number) {
      if (selectedTime.value !== time) {
        selectedTime.value = time
        loadLoanInfo()
      }
    }

    const sliderTooltipFormatter = (v: number) => `${formatNumber(v)} €`

    const inClassifiedView = computed(() => {
      return route.value.name?.startsWith('__classifieds_view')
    })

    async function loadLoanInfo() {
      if (loadingLoanInfo.value) {
        // still loading previous request
        return
      }

      loadingLoanInfo.value = true
      try {
        const { installment } = await loanService.getLoanInfo(
          LoanMerchantName.TBI,
          loanAmount.value,
          loanInstallments.value,
          loanType.value,
          inClassifiedView.value ? state.classifiedId : undefined
        )
        loanInstallment.value = installment
      } catch (error) {
        logger.captureError(error as any)
        loanInstallment.value = getStaticLoanInstallment()
      } finally {
        loadingLoanInfo.value = false

        emit('update-loan-amount', loanAmount.value)
        emit('update-loan-installments', loanInstallments.value)
      }
    }

    const handleAmountChange = debounce(loadLoanInfo, DEBOUNCE_SWIFT)

    function handleGetALoanButtonClick() {
      loanModalIsShown.value = true
    }

    const formattedLoanInstallment = computed(() =>
      loanInstallment.value.toFixed(2)
    )

    const inputWidth = computed(() => {
      const letterWidth = 14 // average
      if (loanAmount.value) {
        return `${formatNumber(loanAmount.value).toString().length *
          letterWidth}px`
      }
      return `${letterWidth}px`
    })

    const onBlur = () => {
      showInput.value = false

      // take the value from the input that was just blured
      const inputValue = Number(inputRef.value.value)

      if (inputValue <= minLoanAmount.value) {
        loanAmount.value = minLoanAmount.value
      } else if (inputValue >= maxLoanAmount.value) {
        loanAmount.value = maxLoanAmount.value
      } else {
        loanAmount.value = inputValue
      }

      handleAmountChange()
    }

    const onLabelClick = async () => {
      if (showInput.value) {
        return
      }
      showInput.value = true
      await nextTick()
      inputRef.value.focus()
      inputRef.value.setSelectionRange(-1, -1)
    }

    const onDragging = (_v: number) => {
      liveLoanAmount.value = _v
    }

    watch(loanAmount, val => {
      liveLoanAmount.value = val
    })

    const yearsArray = [1, 2, 3, 4, 5]
    const monthsArray = [3, 6, 12, 24]
    const timeOptions = ref<number[]>(
      monthModeTrigger.value ? monthsArray : yearsArray
    )
    const nextTimeOptions = ref<number[]>(
      monthModeTrigger.value ? yearsArray : monthsArray
    )

    const enterAnimationAtLine = ref<number>(timeOptions.value.length - 1)
    const leaveAnimationAtLine = ref<number>(-1)

    const triggerAnimation = async (showMonths: boolean) => {
      const previousTimeOptions = [...timeOptions.value]
      const nextTimeOptionsToSet = showMonths ? monthsArray : yearsArray
      if (arraysEqual(nextTimeOptionsToSet, previousTimeOptions)) {
        // we are trying to set the exact same times
        enterAnimationAtLine.value = nextTimeOptionsToSet.length - 1
        return
      }
      nextTimeOptions.value = nextTimeOptionsToSet

      if (enterAnimationAtLine.value === previousTimeOptions.length - 1) {
        leaveAnimationAtLine.value = enterAnimationAtLine.value
      }

      enterAnimationAtLine.value = -1
      await nextTick()
    }

    watch(monthModeTrigger, async val => {
      await triggerAnimation(val)
    })

    const afterLineEnter = () => {
      if (enterAnimationAtLine.value < timeOptions.value.length - 1) {
        enterAnimationAtLine.value++
      }
    }

    const afterLineLeave = async () => {
      if (leaveAnimationAtLine.value >= 0) {
        leaveAnimationAtLine.value--
      }
      if (leaveAnimationAtLine.value === -1) {
        timeOptions.value = nextTimeOptions.value

        if (monthModeTrigger.value && !monthMode.value) {
          // we are going to month mode
          const selectedTimeInMonths = selectedTime.value * 12
          selectedTime.value =
            timeOptions.value.find(t => t === selectedTimeInMonths) ||
            monthsArray[2]
        } else if (!monthModeTrigger.value && monthMode.value) {
          // we are going to year mode
          const selectedTimeInYears = selectedTime.value / 12
          selectedTime.value =
            timeOptions.value.find(t => t === selectedTimeInYears) ||
            yearsArray[3]
        }

        monthMode.value = monthModeTrigger.value

        await nextTick()
        enterAnimationAtLine.value = 0
      }
    }

    const sliderMarks = computed(() => {
      const marks = {
        [minLoanAmount.value.toString()]: {
          label: ``
        },
        [maxLoanAmount.value.toString()]: {
          label: ``
        }
      }
      if (loanType.value === 'consumer-loan' && maxLoanAmount.value > 500) {
        // add the dummy mark at 500 so as to show the difference in colors between the two loan categories
        const markPoint = 500
        const percentage =
          ((markPoint - minLoanAmount.value) /
            (maxLoanAmount.value - minLoanAmount.value)) *
          100

        const containerWidth =
          process.client && sliderRef.value
            ? sliderRef.value.$el.clientWidth
            : 4

        const widthValue = `${(containerWidth * percentage) / 100 - 3}px`

        marks[markPoint.toString()] = {
          label: '',
          style: {
            width: widthValue,
            height: '4px',
            borderRadius: '0px',
            display: 'block',
            backgroundColor: "theme('colors.grey.500')",
            transform: 'translate(-100%, 0px)',
            opacity: 0.5
          }
        }

        // add mark for the classified price
        if (initLoanAmount.value >= 1800 && initLoanAmount.value <= 8000) {
          // > 1800 becuase otherwise it will overlap with the other marks
          marks[initLoanAmount.value.toString()] = {
            label: sliderTooltipFormatter(initLoanAmount.value.toString()),
            labelStyle: {
              color: "theme('colors.grey.500')",
              fontSize: '0.75rem',
              marginTop: '0.8rem',
              cursor: 'pointer'
            }
          }
        }
      }

      return marks
    })

    const onDragEnd = async () => {
      await nextTick()
      triggerAnimation(monthModeTrigger.value)
    }

    const minInstallmentMonths = computed(() => {
      if (monthMode.value) {
        return timeOptions.value[0]
      }
      return timeOptions.value[0] * 12 // to get months
    })
    const maxInstallmentMonths = computed(() => {
      if (monthMode.value) {
        return timeOptions.value[timeOptions.value.length - 1]
      }
      return timeOptions.value[timeOptions.value.length - 1] * 12 // to get months
    })

    const onLogoClick = (e: Event, isExpanded: boolean) => {
      if (isExpanded && !isMobile.value) {
        e.preventDefault()
        e.stopPropagation()
        showTbiInfoModal.value = true
      }
    }

    const onTbiBottomClick = (e: Event) => {
      e.preventDefault()
      e.stopPropagation()
      showTbiInfoModal.value = true
    }

    return {
      selectedTime,
      timeButtonIsSelected,
      handleTimeButtonClick,
      sliderTooltipFormatter,
      loanAmount,
      classifiedRawPrice,
      maxLoanAmount,
      minLoanAmount,
      formatNumber,
      handleAmountChange,
      loanInstallment,
      loadingLoanInfo,
      handleGetALoanButtonClick,
      loanModalIsShown,
      formattedLoanInstallment,
      loanInstallments,
      inputWidth,
      showInput,
      inputRef,
      onBlur,
      onLabelClick,
      onDragging,
      liveLoanAmount,
      monthModeTrigger,
      monthMode,
      timeOptions,
      nextTimeOptions,
      yearsArray,
      monthsArray,
      enterAnimationAtLine,
      leaveAnimationAtLine,
      afterLineEnter,
      afterLineLeave,
      sliderMarks,
      sliderRef,
      triggerAnimation,
      onDragEnd,
      minInstallmentMonths,
      maxInstallmentMonths,
      showTbiInfoModal,
      onLogoClick,
      onTbiBottomClick,
      internalExpanded,
      isMobile,
      t
    }
  },
  i18n: defineComponentTranslations({
    tbi_bank_text: {
      en: 'You only need an account in any bank',
      el: 'Χρειάζεσαι μόνο έναν λογαριασμό σε μια οποιαδήποτε τράπεζα'
    },

    tbi_bank_mortgage_text: {
      en: '{bold} to cover personal needs',
      el: '{bold} κάλυψης προσωπικών αναγκών'
    },
    tbi_bank_mortgage_text_bold: {
      en: 'Financing',
      el: 'Χρηματοδότηση'
    },
    tbi_bottom_disclaimer: {
      en: 'Financing is provided by {bank} and not from the {type}.',
      el: 'Η χρηματοδότηση παρέχεται από την {bank} και όχι από τον {type}.'
    },
    tbi_bottom_disclaimer_vehicle: {
      en: 'seller of the vehicle',
      el: 'πωλητή του οχήματος'
    },
    tbi_bottom_disclaimer_property: {
      en: 'property owner',
      el: 'τον ιδιοκτήτη του ακινήτου'
    },
    tbi_bottom_disclaimer_classified: {
      en: 'seller of the classified',
      el: 'πωλητή της αγγελίας'
    }
  })
})
